import * as React from 'react';
import Select from "react-select";
import { IMultiSelectOption } from '../Types';


interface IMultiSelectProps {
    styles: any;
    initialValue: IMultiSelectOption[];
    options: IMultiSelectOption[];
    onChange: (value: IMultiSelectOption[]) => void;
    valueChange?: (value: IMultiSelectOption[]) => IMultiSelectOption[];
}

interface IMultiSelectState {
    value: IMultiSelectOption[];
    customStyles: any;
}

export class MultiSelect extends React.Component<IMultiSelectProps, IMultiSelectState>{
    constructor(props: IMultiSelectProps) {
        super(props);

        this.state = {
            value: props.initialValue,
            customStyles: {
                ...{
                    multiValueLabel: (provided:any, state:any) => {
                        var newStyle = provided;
                        if (state.data.isDisabled) {
                            newStyle = { ...provided, paddingRight: "6px" };
                        }
                        return newStyle;
                    },
                    multiValueRemove: (provided: any, state: any) => {
                        var newStyle = provided;
                        if (state.data.isDisabled) {
                            newStyle = { ...provided, display: "none" };
                        }
                        return newStyle;
                    },

                }, ...props.styles
            }
        }
    }

    onChange = (value:any, { action, removedValue }:any) => {
        switch (action) {
            case 'remove-value':
            case 'pop-value':
                if (removedValue.isFixed) {
                    return;
                }
                break;
            case 'clear':
                value = this.props.options.filter(v => v.isFixed);
                break;
        }
        //Need this to rerender the multiselect properly if its changed further up the chain
        if(this.props.valueChange){
            value = this.props.valueChange(value);
        }
        this.setState({ value: value }, () => this.props.onChange(value));
    }

    render() {
        return (<Select
            styles={this.state.customStyles}
            isMulti={true}
            options={this.props.options}
            isClearable={this.state.value.some(v => !v.isFixed)}
            onChange={this.onChange}
            value={this.state.value}
        />);
    }
}